export let InformationFieldsJSON = {
  "1719381246009-customSelect": {
    elementid: 1719381246009,
    elementtype: "customSelect",
    "data-datasource": "customvalues",
    "database-label": "status",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-disabled": 1,
    "display-required": 1,
    "display-placeholder": "Select",
  },
  "1719381296940-number": {
    elementid: 1719381296940,
    elementtype: "number",
    "display-fieldlabel": "Contact Number",
    "display-labelposition": "top",
    "database-label": "pri_contact_number",
    "display-required": 1,
  },
  "1719381237579-columns": {
    elementid: 1719381237579,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381275577-columns": {
    elementid: 1719381275577,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381280207-columns": {
    elementid: 1719381280207,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381283974-columns": {
    elementid: 1719381283974,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381221960-fieldset": {
    elementid: 1719381221960,
    elementtype: "fieldset",
    "display-fieldlabel": "Company Details",
  },
  "1719381266926-fieldset": {
    elementid: 1719381266926,
    elementtype: "fieldset",
    "display-fieldlabel": "Primary Contact",
  },
  "1719381241192-textfield": {
    elementid: 1719381241192,
    elementtype: "textfield",
    "display-fieldlabel": "Organization Name",
    "database-label": "name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719381288490-textfield": {
    elementid: 1719381288490,
    elementtype: "textfield",
    "display-fieldlabel": "Name",
    "database-label": "pri_contact_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719381292523-textfield": {
    elementid: 1719381292523,
    elementtype: "textfield",
    "display-fieldlabel": "Email",
    "database-label": "pri_contact_email",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719381302373-textfield": {
    elementid: 1719381302373,
    elementtype: "textfield",
    "display-fieldlabel": "Department",
    "database-label": "department",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719381306940-textfield": {
    elementid: 1719381306940,
    elementtype: "textfield",
    "display-fieldlabel": "Designation",
    "database-label": "pri_contact_designation",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1717412405877-documentFile": {
    elementid: 1717412405877,
    elementtype: "documentFile",
    "display-fieldlabel": "Add Logo",
    "display-required": 0,
    "database-label": "logo_media_id",
    "display-labelposition": "top",
  },
  "1717412405888-documentFile": {
    elementid: 1717412405888,
    elementtype: "documentFile",
    "display-fieldlabel": "Add Icon",
    "display-required": 0,
    "database-label": "icon_media_id",
    "display-labelposition": "top",
  },
};

export let CompanyDetailsFieldsJSON = {
  "1719381246009-select": {
    elementid: 1719381246009,
    elementtype: "select",
    "data-datasource": "customvalues",
    "database-label": "status",
    "data-customvalue": "ACTIVE#INACTIVE",
    "display-fieldlabel": "Status",
    "display-noofcolumns": "2",
    "display-labelposition": "top",
    "display-disabled": 1,
    "display-required": 1,
  },
  "1719381241192-textfield": {
    elementid: 1719381241192,
    elementtype: "textfield",
    "display-fieldlabel": "Organization Name",
    "database-label": "name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1717412405877-documentFile": {
    elementid: 1717412405877,
    elementtype: "documentFile",
    "display-fieldlabel": "Add Logo",
    "display-required": 0,
    "database-label": "logo_media_id",
    "display-labelposition": "top",
  },
  "1717412405888-documentFile": {
    elementid: 1717412405888,
    elementtype: "documentFile",
    "display-fieldlabel": "Add Icon",
    "display-required": 0,
    "database-label": "icon_media_id",
    "display-labelposition": "top",
  },
};

export let PrimaryDetailsFieldsJSON = {
  "1719381296940-number": {
    elementid: 1719381296940,
    elementtype: "number",
    "display-fieldlabel": "Contact Number",
    "display-labelposition": "top",
    "database-label": "pri_contact_number",
    "display-required": 1,
  },
  "1719381237579-columns": {
    elementid: 1719381237579,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381275577-columns": {
    elementid: 1719381275577,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381280207-columns": {
    elementid: 1719381280207,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381283974-columns": {
    elementid: 1719381283974,
    elementtype: "columns",
    "display-fieldlabel": "Columns",
    "display-noofcolumns": "2",
  },
  "1719381221960-fieldset": {
    elementid: 1719381221960,
    elementtype: "fieldset",
    "display-fieldlabel": "Company Details",
  },
  "1719381266926-fieldset": {
    elementid: 1719381266926,
    elementtype: "fieldset",
    "display-fieldlabel": "Primary Contact",
  },
  "1719381288490-textfield": {
    elementid: 1719381288490,
    elementtype: "textfield",
    "display-fieldlabel": "Name",
    "database-label": "pri_contact_name",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719381292523-textfield": {
    elementid: 1719381292523,
    elementtype: "textfield",
    "display-fieldlabel": "Email",
    "database-label": "pri_contact_email",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719381302373-textfield": {
    elementid: 1719381302373,
    elementtype: "textfield",
    "display-fieldlabel": "Department",
    "database-label": "department",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
  "1719381306940-textfield": {
    elementid: 1719381306940,
    elementtype: "textfield",
    "display-fieldlabel": "Designation",
    "database-label": "pri_contact_designation",
    "validation-maxlength": "2000",
    "validation-minlength": "0",
    "display-labelposition": "top",
    "display-required": 1,
  },
};

export const UploadFieldsJSON = {
  "1717412405877-documentFile": {
    elementid: 1717412405877,
    elementtype: "documentFile",
    "display-fieldlabel": "Add Logo",
    "display-required": 0,
    "database-label": "logo_media_id",
    "display-labelposition": "top",
  },
  "1717412405888-documentFile": {
    elementid: 1717412405888,
    elementtype: "documentFile",
    "display-fieldlabel": "Add Icon",
    "display-required": 0,
    "database-label": "icon_media_id",
    "display-labelposition": "top",
  },
};
